import React, { Component } from 'react';
import classnames from 'classnames';
import './index.less';
import {
  isFromFlow360,
  isFromTidy3d,
  isFromPhotonforge,
} from '../../utils/util';
import logo from '../../assets/logo.svg';
import FlexcomputeLogo from '../../assets/flexcompute_logo.svg';
import flow360Logo from '../../assets/flow360_logo.svg';
import tidy3dLogo from '../../assets/tidy3d_logo.svg';
import SideBanner from '../SideBanner';
import { PhotonForgeBannerItems, Tidy3dBannerItems } from '@/constants';
import backgroundRight from '../../assets/background_right.png';
import backgroundLeft from '../../assets/background_left.png';

export interface AuthLayoutProps {
  isFlow360?: boolean;
  isTidy3d?: boolean;
  isPhotonforge?: boolean;
  showLogo?: boolean;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}
export default class AuthLayout extends Component<AuthLayoutProps> {
  render() {
    const {
      isFlow360: isFlow360Props,
      isTidy3d: isTidy3dProps,
      isPhotonforge: isPhotonforgeProps,
      showLogo = false,
      style,
    } = this.props;
    const isFlow360 = isFlow360Props || isFromFlow360();
    const isTidy3d = isTidy3dProps || isFromTidy3d();
    const isPhotonforge = isPhotonforgeProps || isFromPhotonforge();
    const isDefault = !isFlow360 && !isTidy3d && !isPhotonforge;
    const { children } = this.props;
    return (
      <>
        <div
          className={classnames('auth_layout', {
            flow360: isFlow360,
            tidy3d: isTidy3d,
            photonforge: isPhotonforge,
          })}
        >
          {isTidy3d && (
            <div className="banner_wrapper">
              <SideBanner items={Tidy3dBannerItems} />
            </div>
          )}
          {isPhotonforge && (
            <div className="banner_wrapper">
              <SideBanner items={PhotonForgeBannerItems} />
            </div>
          )}
          <div className="auth_content_wrapper">
            <img
              src={backgroundRight}
              alt="background_right"
              className="background_right"
            />
            {!isTidy3d && !isPhotonforge && (
              <img
                src={backgroundLeft}
                alt="background_left"
                className="background_left"
              />
            )}

            <div className="auth_content_container">
              <div className="auth_content" style={style}>
                <div className="logo_wrapper">
                  <img
                    width={168}
                    src={FlexcomputeLogo}
                    alt={'FlexCompute logo'}
                    className="flexcompute_logo"
                  />
                </div>
                {showLogo && (
                  <div className="logo_wrapper">
                    {isFlow360 && (
                      <img src={flow360Logo} alt={'Flow360 logo'} width={204} />
                    )}
                    {isTidy3d && (
                      <img src={tidy3dLogo} alt={'Tidy3d logo'} width={204} />
                    )}
                    {isPhotonforge && (
                      <img
                        src={tidy3dLogo}
                        alt={'PhotonForge logo'}
                        width={204}
                      />
                    )}
                    {isDefault && <img src={logo} alt={'Flexcompute logo'} />}
                  </div>
                )}
                {children}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
